module.exports = __webpack_public_path__ + "img/03_uk.d9284827.svg";